export enum ProcessStatus {
  Ready = 0,
  Processing = 1,
  Processed = 2,
  Failed = 3
}
